import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';
import { CommonService } from './common.service';

import { SystemParameter, SystemParameterSearchingCriteria } from "@models/system-parameter";
import { map, catchError } from 'rxjs/operators';
import { HttpClient, HttpParams } from '@angular/common/http';
import { PageResponse } from '@app/models/page-response';

@Injectable()
export class SystemParameterService {

    constructor(
        private httpClient: HttpClient,
        private commonService: CommonService
    ) { }

    getAll(): Observable<SystemParameter> {
        return this.httpClient.get(`${environment.API_END_POINT}/systemParams`, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response => <SystemParameter>(<any>response).content),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );
    }

    getByCode(systemParameterCode: string): Observable<SystemParameter> {

        let params: HttpParams = new HttpParams();
        params = params.set('code', systemParameterCode);

        return this.httpClient.get(`${environment.API_END_POINT}/systemParams`, { headers: this.commonService.getHeaders(), params: params })
            .pipe(
                map(response => <SystemParameter>(<any>response).content),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );
    }

    update(systemParameter: SystemParameter): Observable<SystemParameter> {

        let body = JSON.stringify(systemParameter);

        return this.httpClient.put(`${environment.API_END_POINT}/systemParams`, body, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response => <SystemParameter>(<any>response).content),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );

    }

    
    get(id: string): Observable<SystemParameter> {
        return this.httpClient.get(`${environment.API_END_POINT}/systemParams/${id}`, { headers: this.commonService.getHeaders() })
            .pipe(
                map(response =>  {
                    let tempObj = <SystemParameter>((<any>response).content);
                    return tempObj;
                }),
                catchError((error: Response | any) => this.commonService.handleHttpError(error))
            );
    }


    
  globalSearch(globalCriteria: string = '', criteria: SystemParameterSearchingCriteria, page: number = 0, size: number = 10, sortField: string, sortDirection: string = 'asc'): Observable<PageResponse<SystemParameter>> {

    let params: HttpParams = new HttpParams();
    params = params.set('global', globalCriteria);
    params = params.set('criteria', JSON.stringify(criteria == null ? new SystemParameterSearchingCriteria() : criteria));
    params = params.set('page', page.toString());
    params = params.set('size', size.toString());
    if (sortField != null) {
        params = params.set('sort', sortField + ',' + sortDirection);
    }

    return this.httpClient.get(`${environment.API_END_POINT}/systemParams`, { headers: this.commonService.getHeaders(), params: params })
        .pipe(
            map(response => {
                let tempObj = <SystemParameter[]>(<any>response);
                return tempObj;
            }),
            catchError((error: Response | any) => this.commonService.handleHttpError(error))
        );
} 
}